export default "__VITE_ASSET__BkxBKbdA__"